<!-- Encabezado del diálogo -->
<div mat-dialog-title class="dialog-header">
    <div class="header-content">
        <mat-icon class="header-icon">picture_as_pdf</mat-icon>
        <div class="header-text">
            <h2>Documentos PDF - O/S: {{numeroOrdenServicio}}</h2>
            <p class="text-muted">Documentos PDF asociados a la orden de servicio</p>
        </div>
    </div>
    <button mat-icon-button (click)="cerrar()" class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Contenido del diálogo -->
<mat-dialog-content class="dialog-content">
    <!-- Lista de archivos -->
    <div class="mat-mdc-card files-section">
        <div class="mat-mdc-card-header">
            <div class="mat-mdc-card-title">
                <mat-icon>description</mat-icon>
                Documentos PDF Asociados
            </div>
        </div>

        <div class="mat-mdc-card-content">
            <!-- Estado de carga -->
            <div *ngIf="isLoading" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Cargando archivos...</p>
            </div>

            <!-- Tabla de archivos -->
            <div class="table-container" *ngIf="!isLoading">
                <table mat-table [dataSource]="archivos" class="files-table">
                    <!-- Columna Archivo -->
                    <ng-container matColumnDef="archivo">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let archivo">
                            <div class="file-info">
                                <mat-icon class="file-icon">insert_drive_file</mat-icon>
                                <span class="file-name">{{archivo.nombre}}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Columna Tipo -->
                    <ng-container matColumnDef="tipo">
                        <th mat-header-cell *matHeaderCellDef>Tipo</th>
                        <td mat-cell *matCellDef="let archivo">
                            <mat-chip class="type-chip">{{archivo.tipo}}</mat-chip>
                        </td>
                    </ng-container>

                    <!-- Columna Comentarios -->
                    <ng-container matColumnDef="comentarios">
                        <th mat-header-cell *matHeaderCellDef>Comentarios</th>
                        <td mat-cell *matCellDef="let archivo">
                            {{archivo.comentarios || '—'}}
                        </td>
                    </ng-container>

                    <!-- Columna Creado por -->
                    <ng-container matColumnDef="creadoPor">
                        <th mat-header-cell *matHeaderCellDef>Creado por</th>
                        <td mat-cell *matCellDef="let archivo">
                            {{archivo.creadoPor}}
                        </td>
                    </ng-container>

                    <!-- Columna Fecha creación -->
                    <ng-container matColumnDef="fechaCreacion">
                        <th mat-header-cell *matHeaderCellDef>Fecha creación</th>
                        <td mat-cell *matCellDef="let archivo">
                            {{archivo.fechaCreacion}}
                        </td>
                    </ng-container>

                    

                    <!-- Definición de filas -->
                    <tr mat-header-row *matHeaderRowDef="['archivo', 'tipo', 'comentarios', 'creadoPor', 'fechaCreacion']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['archivo', 'tipo', 'comentarios', 'creadoPor', 'fechaCreacion'];"></tr>
                </table>

                <!-- Mensaje sin archivos -->
                <div *ngIf="archivos.length === 0" class="no-files">
                    <mat-icon>folder_off</mat-icon>
                    <h3>No hay archivos</h3>
                    <p>No se encontraron archivos adjuntos para esta orden de servicio.</p>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<!-- Acciones del diálogo -->
<mat-dialog-actions align="end">
    <button 
        mat-raised-button 
        color="primary"
        (click)="descargarTodos()"
        [disabled]="archivos.length === 0">
        <mat-icon>download_all</mat-icon>
        Descargar todos
    </button>
    <button mat-stroked-button (click)="cerrar()">
        <mat-icon>close</mat-icon>
        Cerrar
    </button>
</mat-dialog-actions>
